import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';

const SlidingToggle = ({ options, width = '100%', value, onChange }) => {

  const [selectedIndex, setSelectedIndex] = useState(0);

  const toggle = (index) => {
    setSelectedIndex(index);
  };

  useEffect(() => {
    if (value) {
      setSelectedIndex(options.indexOf(value));
    }
  }, [value, options]);


  return (
    <div className={styles.slidingContainer} style={{ width }}>
      <div
        className={styles.slider}
        style={{ width: `${100 / options.length}%`, transform: `translateX(${selectedIndex * 100}%)` }}
      ></div>
      {options.map((option, index) => (
        <span
          key={index}
          className={selectedIndex === index ? styles.active : ""}
          onClick={() => {
            toggle(index);
            onChange(option);
          }}
        >
          {option}
        </span>
      ))}
    </div>
  )
}

export default SlidingToggle;